import OperationParameterFormConfig from "../operatingParameter/OperationParametrFormConfig";
import OperationParameterGroupFormConfig from "../operatingParameter/group/OperationParameterGroupFormConfig.js";
import OperationParameterTableConfig from "../operatingParameter/OperationParametrTableConfig";
import OperationParameterGroupTableConfig from "../operatingParameter/group/OperationParameterGroupTableConfig";
import {hasAdminPanelFullAccess} from "../../helpers/jwt";

export const dictionaries = (t) => [
    {
        api: 'operatingParameterTemplate',
        label: t ? t("object_types.operating_parameter_template") : 'Parametry pracy',
        creationLabel: t ? t("parameters.creation") : 'Dodaj parametr prac',
        fields: OperationParameterFormConfig(t),
        columns: OperationParameterTableConfig(t),
        editable: true,
        editWithId: true,
        readOnly: !hasAdminPanelFullAccess(),
        deleteModalTitle: t ? t("confirmations.parameter_deletion_title") : "Usunięcie parametru pracy",
        deleteModalDescription: t ? t("confirmations.are_you_sure_delete_parameter") : "Czy napewno chcesz usunąć parametr pracy?",
    },
    {
        api: 'operatingParameterTemplate/group',
        label: t ? t("object_types.operating_parameter_template_group") : 'Grupy parametrów pracy',
        creationLabel: t ? t("common.add_group") : 'Dodaj grupę',
        fields: OperationParameterGroupFormConfig(t),
        columns: OperationParameterGroupTableConfig(t),
        editable: true,
        editWithId: true,
        readOnly: !hasAdminPanelFullAccess(),
        deleteModalTitle: t ? t("confirmations.parameter_group_deletion_title") : "Usunięcie grupy parametrów pracy",
        deleteModalDescription: t ? t("confirmations.are_you_sure_delete_parameter_group") : "Czy napewno chcesz usunąć grupę parametrów pracy?",
        modalSize: "xl"
    },

    {
        api: 'fastActingPart/category',
        label: t ? t("object_types.fast_acting_part_category") : 'Części szybkozużywające się',
        tableLabel: t ? t("common.categories") : "Kategorie",
        creationLabel: t ? t("common.add_category") : "Dodaj kategorię",
        deleteModalTitle: t ? t("confirmations.category_deletion_title") : "Usunięcie kategorii",
        deleteModalDescription: t ? t("confirmations.are_you_sure_delete_category") : "Czy napewno chcesz usunąć kategorie?",
        readOnly: !hasAdminPanelFullAccess(),
    }
]
